module.exports = __webpack_public_path__ + "static/img/download-phone.3951eef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download-phone.png
// module id = tB9J
// module chunks = 0